import { Component, Inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DwSecurityUserService, DwSecurityRepositoryServiceToken, DwSecurityRepositoryService, DwUser } from '@devwareapps/devware-cap';
import { AviatorOnlineUserTypeIds } from '../../../shared/models/aviator-user-type.enum';
import { SubscriptionFeatureKeys, UserTypeAllItems } from '../../../../meta-data/app-meta-data.service';
import { AviatorUser } from '../../../shared/models/aviator-user.model';
import { AppPermissions } from '../../../../meta-data/app-permissions.enum';
import { AdminManagerService } from '../../../admin/services/admin-manager.service';
import { SchoolRepositoryService } from '../../../schools/services/school-repository.service';
import { PostLoginExperienceService } from '../../../post-login/services/post-login-experience.service';

@Component({
  selector: 'app-authenticated-home-view',
  templateUrl: './authenticated-home-view.component.html',
  styleUrls: ['./authenticated-home-view.component.scss']
})
export class AuthenticatedHomeViewComponent implements OnInit {
  aviatorUser: AviatorUser;
  dashboardUserTypeId?: number = UserTypeAllItems.Student; // Default to student dashboard
  dashboardName?: string;
  readonly UserTypeAllItems = UserTypeAllItems;

  showDashboardSelect: boolean = false;
  canChangeDashbaord: boolean = false;
  hasAssignmentsFeature: boolean;

  useMainDashboard: boolean = true;
  useDashboardRedesign: boolean = true;

  constructor(private router: Router,
    private dwSecurityUserService: DwSecurityUserService,
    @Inject(DwSecurityRepositoryServiceToken) private dwSecurityRepositoryService: DwSecurityRepositoryService,
    private adminManagerService: AdminManagerService,
    private schoolRepositoryService: SchoolRepositoryService,
    private postLoginExperienceService: PostLoginExperienceService

  ) { }

  ngOnInit(): void {
    this.dwSecurityUserService.securityContextChanged().subscribe(change => {
      this.setupSecurity();
    });

    this.setupSecurity();
  }


  changeDashboardType(userTypeId: string) {
    if (!this.canChangeDashbaord) {
      return;
    }

    this.dashboardUserTypeId = parseInt(userTypeId);
    this.setDashbaordName();

    this.showDashboardSelect = false;
  }

  toggleChangeDashboard() {
    if (!this.canChangeDashbaord) {
      return;
    }

    this.showDashboardSelect = !this.showDashboardSelect;
  }

  private setupSecurity() {
    if (!this.dwSecurityUserService.securityState.isAuthenticated || this.dwSecurityUserService.securityState.isAuthenticating) {
      return;
    }

    this.schoolRepositoryService.hasFeatureWithLoad(SubscriptionFeatureKeys.Assignments)
      .subscribe(hasAssignmentsFeature => {
        this.hasAssignmentsFeature = hasAssignmentsFeature

        this.setupDashboard();
      });
  }

  setupDashboard() {


    const user = this.dwSecurityUserService.securityContext.ApplicationUser;

    this.aviatorUser = this.adminManagerService.getAviatorUser(user);

    this.dashboardUserTypeId = this.aviatorUser.UserTypeId;

    if (!this.hasAssignmentsFeature) {
      switch (this.dashboardUserTypeId) {
        // Convert flight instructors to students
        case AviatorOnlineUserTypeIds.flightInstructor:
          this.dashboardUserTypeId = AviatorOnlineUserTypeIds.student;
          break;
      }
    }

    this.postLoginExperienceService.run();

    // this.dashboardUserTypeId = AviatorOnlineUserTypeIds.student;

    // if (this.dwSecurityUserService.hasPermission(AppPermissions.flightSchoolAccess)) {
    //   this.dashboardUserTypeId = AviatorOnlineUserTypeIds.flightSchool;
    //   this.canChangeDashbaord = true;
    // }

    // if (this.dwSecurityUserService.hasPermission(AppPermissions.instructorAccess)) {
    //   this.dashboardUserTypeId = AviatorOnlineUserTypeIds.flightInstructor;
    // }

    this.setDashbaordName();
  }
  // setupDashboard() {
  //   throw new Error('Method not implemented.');
  // }

  private setDashbaordName() {
    switch (this.dashboardUserTypeId) {
      case AviatorOnlineUserTypeIds.student:
        this.dashboardName = 'Student Dashboard';
        break;
      case AviatorOnlineUserTypeIds.flightInstructor:
        this.dashboardName = 'Instructor Dashboard';
        break;
      case AviatorOnlineUserTypeIds.flightSchool:
        this.dashboardName = 'School Dashboard';
        break;
    }
  }
}
